module.exports = __webpack_public_path__ + "static/media/22.db495f85.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/22.png
// module id = 1396
// module chunks = 0